import en from "./en";
import es from "./es";
import pt from "./pt";
export var LOCALES = {
  es: es,
  pt: pt,
  en: en
};